<template>
  <modal transition="pop-out" name="new-micro-category" :width="550" :height="620">
    <div class="h-10 w-full border-b border-gray-200">
      <p class="px-8 py-2 text-gray-700 font-bold">Create MicroCategory</p>
    </div>
    <div class="w-full">
      <form class="rounded px-8 pt-6 pb-8 mb-4" @submit.prevent>
        <div class="mb-4 mb-6">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Name
          </label>
          <input v-model="form.name" class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="text" placeholder="Category Name">
          <p v-if="errors.includes('name')" class="text-red-500 text-xs italic">Please provide a name.</p>
        </div>
        <div class="mb-4 mb-6">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Category
          </label>
          <el-select :disabled="disabled" v-model="form.category_id" @change="setSubCategories()" placeholder="Select">
            <el-option
              v-for="item in categories"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <p v-if="errors.includes('category_id')" class="text-red-500 text-xs italic">Please provide a category.</p>
        </div>
        <div class="mb-4 mb-6">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Sub Category
          </label>
          <el-select :disabled="disabled" :no-data-text="'No Subcategory'" v-model="form.sub_category_id" placeholder="Select">
            <el-option
              v-for="item in subCategories"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <p v-if="errors.includes('category_id')" class="text-red-500 text-xs italic">Please provide a sub category.</p>
        </div>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Description
          </label>
          <textarea v-model="form.description" class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="text" placeholder="Description...."></textarea>
          <p v-if="errors.includes('description')" class="text-red-500 text-xs italic">Please provide some description.</p>
        </div>
        <div class="mb-10" v-if="false">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Image
          </label>
          <input type="file" ref="file" accept="image/*">
          <p v-if="false" class="text-red-500 text-xs italic">Please fill all fields.</p>
        </div>
        <div class="mb-10">
          <el-tag
            class="mr-1"
            :key="tag"
            v-for="tag in dynamicTags"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)">
            {{tag}}
          </el-tag>
          <el-input
            class="input-new-tag"
            :class="{'ml-1':dynamicTags.length > 0}"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="mini"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          >
          </el-input>
          <el-button v-else class="button-new-tag" :class="{'ml-1':dynamicTags.length > 0}" size="small" @click="showInput">+ New Tag</el-button>
        </div>
        <div class="flex items-center justify-between">
          <el-button @click="submit" type="primary" :loading="creating">Create</el-button>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'CreateForm',
  data() {
    return {
      creating: false,
      errors: [],
      disabled: true,
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      subCategories: [],
      form: {
        name: '',
        description: '',
        category_id: '',
        sub_category_id: '',
      },
    };
  },
  computed: {
    categories() {
      return this.$store.getters['InventoryModule/Catalog/getCategoryForSelect'];
    },
  },
  methods: {
    async submit() {
      this.errors = [];
      // formValidation is a mixin in
      // src/Common/mixins/index.js
      this.errors = this.formValidation(this.form);

      // check for error length
      if (this.errors.length === 0) {
        try {
          this.creating = true;

          const response = await this.$store.dispatch('InventoryModule/Catalog/createMicroCategory', {
            form: this.form,
            category: this.getSelectedCategory(),
            subCategory: this.getSelectedSubCategory(),
          });
          this.$modal.hide('new-micro-category');

          this.$notify.warning({
            title: 'Success',
            message: 'Catalog has been updated, now add an image.',
          });
          // Display image upload modal
          this.$emit('imageUpload', response.id);
        } catch (e) {
          this.creating = false;
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong',
          });
        }

        this.creating = false;
      }
    },

    getSelectedCategory() {
      return this.categories.filter(item => item.value === this.form.category_id);
    },

    getSelectedSubCategory() {
      return this.subCategories.filter(item => item.value === this.form.sub_category_id);
    },

    setSubCategories() {
      this.subCategories = this.$store.getters['InventoryModule/Catalog/getSubCategoryForSelect'](this.form.category_id);
    },
    handleClose(tag) {
      this.form.meta_data.splice(this.form.meta_data.indexOf(tag), 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      if (this.inputValue) {
        this.dynamicTags.push(this.inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
  },

  mounted() {
    if (this.$route.name === 'micro-category') {
      this.form.category_id = parseInt(this.$route.params.category_id, 10);
      this.setSubCategories(parseInt(this.$route.params.category_id, 10));
      this.form.sub_category_id = parseInt(this.$route.params.subCategory_id, 10);
    } else {
      this.disabled = false;
    }
  },
};
</script>

<style scoped>
  .button-new-tag {
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    vertical-align: bottom;
  }
</style>
